'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initFreeBets = function initFreeBets(selector) {
    var link = (0, _jquery2.default)(selector);

    link.on('click', function () {
        if (!['xn', 'n'].includes(_rpMqBreakpoints2.default.current().code)) {
            link.attr('target', '_blank');
        } else {
            link.attr('target', '');
        }
    });
};

exports.default = initFreeBets;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/utils/freeBets.js
// module id = 1337
// module chunks = 0